import InputMail from '@/components/InputMail'

export default
{
    components:
    {
        InputMail
    },

    props:
    {
        isSubmitted: { type: Boolean, default: false }
    },

    methods:
    {
        submit()
        {
            this.$emit('submit')
        }
    }
}
